import { gql } from '@apollo/client';

const InvoiceDocumentFinanceStateFields = gql`
  fragment InvoiceDocumentFinanceStateFields on InvoiceType {
    uniqueDocumentFinanceState {
      id
      status {
        id
        code
      }
    }
    lightningPaymentState @client
  }
`;

export default InvoiceDocumentFinanceStateFields;
